import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProductoEstadoRelacion } from '../../../_models/producto-estado-relacion';
import { NavService } from '../../../_services/_nav.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ProductoEstadoRelacionRolService } from '../../../_services/producto-estado-relacion-rol.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RolesService } from '../../../_services/roles.service';
import { forkJoin } from 'rxjs';
import { Rol } from '../../../_models/rol';
import { ProductoEstadoRelacionRol } from '../../../_models/producto-estado-relacion-rol';

@Component( {
  selector: 'app-producto-estado-aliado-rol',
  templateUrl: 'producto-estado-aliado-rol.component.html'
} )

export class ProductoEstadoAliadoRolComponent implements OnInit {

  @Input() proEstadoCambio: ProductoEstadoRelacion;
  @Output() dismiss: EventEmitter<boolean> = new EventEmitter();
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  carInformacionInicial = true;
  lisTodosRoles: Rol[] = [];
  lisRoles: SelectItem[] = [];
  lisProductoEstadoCambioRol: ProductoEstadoRelacionRol[] = [];

  constructor( private proEstadoCambioRolServicio: ProductoEstadoRelacionRolService,
               private navServicio: NavService, private conServicio: ConfirmationService,
               private fb: FormBuilder, private rolServicio: RolesService ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'nomnbreRol', header: this.navServicio.buscarMensaje( 'PRODUCTOESTADO.LBL_ROL' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    forkJoin( this.proEstadoCambioRolServicio.listadoPorProductoEstadoRelacion( this.proEstadoCambio.idProductoEstadoRelacion ), this.rolServicio.listRoles() ).subscribe( ( [ lisProductosEstadosRol, lisRoles ] ) => {
      this.lisTodosRoles = lisRoles;
      this.lisProductoEstadoCambioRol = lisProductosEstadosRol;
      this.cargarFormulario();
      this.cargarListadoRoles();
      this.carInformacionInicial = false;
    } );
  }

  cargarListadoRoles() {
    this.lisRoles = [];
    this.lisTodosRoles.map( ( s: Rol ) => {
      if ( s.indicadorHabilitado && !this.lisProductoEstadoCambioRol.find( x => x.idRol === s.idRol ) ) {
        this.lisRoles.push( { label: s.nombre, value: s.idRol } );
      }
    } );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idProductoEstadoRol: [ null ],
      idProductoEstadoRelacion: [ this.proEstadoCambio.idProductoEstadoRelacion, [ Validators.required ] ],
      idRol: [ null, [ Validators.required ] ],
      indicadorHabilitado: [ true ],
      auditoriaFecha: [ null ],
      auditoriaUsuario: [ null ]
    } );
  }

  regresar() {
    this.dismiss.emit( true );
  }

  get f() {
    return this.formulario.controls;
  }

  inhabilitar( proEstadoRol: ProductoEstadoRelacionRol ) {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'producto-estado-relacionar-rol',
      accept: () => {
        this.carInformacionInicial = true;
        proEstadoRol.indicadorHabilitado = false;
        this.proEstadoCambioRolServicio.actualizar( proEstadoRol ).subscribe( regActualizado => {
          const a = this.lisProductoEstadoCambioRol.findIndex( x => x.idProductoEstadoRelacionRol === proEstadoRol.idProductoEstadoRelacionRol );
          if ( a >= 0 ) {
            this.lisProductoEstadoCambioRol.splice( a, 1 );
          }
          this.cargarListadoRoles();
          this.carInformacionInicial = false;
        } );
      },
      reject: () => {
      }
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      const proEstadoCambioRol = this.formulario.value;
      this.proEstadoCambioRolServicio.crear( proEstadoCambioRol ).subscribe( estadoRol => {
        proEstadoCambioRol.idProductoEstadoRol = estadoRol.idProductoEstadoRelacionRol;
        const a = this.lisTodosRoles.find(x => x.idRol === estadoRol.idRol);
        if(a){
          proEstadoCambioRol.nombreRol = a.nombre;
        }
        this.lisProductoEstadoCambioRol = [ ...this.lisProductoEstadoCambioRol, proEstadoCambioRol ];
        this.formulario.reset();
        this.f.idProductoEstadoRelacion.setValue( this.proEstadoCambio.idProductoEstadoRelacion );
        this.f.indicadorHabilitado.setValue( true );
        this.cargarListadoRoles();
        this.submitted = false;
        this.guardando = false;
        this.navServicio.setMesage( 1 );
      }, error => {
        this.guardando = false;
        this.navServicio.setMesage( 3 );
      } );
    }
  }
}
